import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {TextField} from "@mui/material";
import {useTranslation} from "react-i18next";
import {RENDERER_TYPES} from "../constants";

export const EmailFieldTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.emailField);

export const EmailFieldRenderer = withJsonFormsControlProps(
  ({label, data, handleChange, path, visible, required, errors}) => {
    const {t} = useTranslation();
    if (!visible) {
      return null;
    }
    return (
      <TextField
        type="email"
        fullWidth
        label={label}
        required={required}
        error={!!errors}
        helperText={errors ? t("components.customJsonForms.emailFieldRenderer.error.text") : undefined}
        variant="outlined"
        value={data || ""}
        onChange={event => handleChange(path, event.target.value ? event.target.value : undefined)}
        className="custom-json-forms__renderers__email-field"
      />
    );
  }
);
